import { Box } from '@mui/material';
import { Sidebar } from 'react-admin';
import CustomMenu from './Menu';
import CustomAppBar from './AppBar';
import palette from '../theme/palette';
import { DRAWER_WIDTH } from '../constant';

const MyLayout = ({ children }) => (
  <Box display="flex" flexDirection="column" minHeight="100vh">
    <CustomAppBar />
    <Box display="flex" flexGrow={1} maxHeight="calc(100vh - 64px)">
      {/* Fixed Sidebar (No Scroll) */}
      <Sidebar
        sx={{
          backgroundColor: palette.background.paper,
          width: DRAWER_WIDTH, // Sidebar width
          height: "calc(100vh - 64px)",
          position: "sticky", // Keeps it visible while scrolling
          top: 0, // Stick to the top
          overflow: "hidden", // Prevent scrolling inside sidebar
          flexShrink: 0, // Prevents sidebar from resizing
        }}
      >
        <CustomMenu />
      </Sidebar>

      {/* Main Content (Scrollable) */}
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        p={3}
        sx={{
          overflowY: "auto", // Allow scrolling only in the content area
          height: "calc(100vh - 64px)", // Ensure full height for scrolling
        }}
      >
        {children}
      </Box>
    </Box>
  </Box>
);

export default MyLayout;
export { MyLayout };
